import axios from 'src/libs/axios';

const downloadSingleCsv = (url: string, lang: string) => {
  return axios({
    responseType: 'blob',
    method: 'get',
    url,
    headers: {
      'Accept-Language': lang,
    },
  });
};

const uploadFileCsv = (
  url: string,
  data: Payload.UploadFileCsvPriceQuotes,
  lang: string,
) => {
  const formData = new FormData();
  formData.append('file', data?.file as File, data.file.name);
  return axios<any>({
    url,
    method: 'post',
    data: formData,
    headers: {
      'Accept-Language': lang,
      enctype: 'multipart/form-data',
    },
  });
};

const getQuotations = (args: any) => {
  const [url, params, lang] = args.queryKey;

  return axios({
    method: 'get',
    url,
    params,
    headers: {
      'Accept-Language': lang,
    },
  });
};

const postEstimatePrices = (
  url: string,
  data: Payload.EstimatePrice,
  lang: string,
) => {
  return axios({
    method: 'post',
    url,
    data,
    headers: {
      'Accept-Language': lang,
    },
  });
};

const exportPDF = (url: string, data: Payload.ExportPDF) => {
  return axios({
    responseType: 'blob',
    method: 'post',
    url,
    data,
  });
};

export default {
  downloadSingleCsv,
  uploadFileCsv,
  getQuotations,
  postEstimatePrices,
  exportPDF,
};
